/**
 * Employee Incident Common Mapper
 * Shared formatting helpers used across employee incident mappers
 */

/**
 * Formats ISO date-time string to DD/MM/YYYY
 */
export function formatDateToDDMMYYYY(isoDate: string | null): string {
  if (!isoDate) return '-';
  try {
    const date = new Date(isoDate);
    if (Number.isNaN(date.getTime())) return '-';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch {
    return '-';
  }
}
